import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { Alert, Button } from "@mui/material";

import ListView from "../ListView/ListView";
import { getSubscribedReleases, getSubscriptionData, getActiveSources, getUserIdFromPreference } from "../../Services";
import Loader from "../Common/Loader/Loader";
import { createColorCodeForRelease } from "../../utility";

export const SubscribedReleases = () => {
  const navigate = useNavigate();
  const [isLoading, setLoader] = useState(true);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [monthlyDigest, setDigest] = useState(false);
  const loggedIn = sessionStorage.getItem("isLoggedIn") === "true";
  const [notificationType, setNotificationType] = useState("");

  useEffect(() => {
    const pathname = window.location.pathname;
    setLoader(true);

    if (loggedIn) {
      sessionStorage.removeItem("path");
    } else {
      const pathMap = {
        "/subscribed-weekly-releases": "subscribed-weekly-releases",
        "/subscribed-monthly-releases": "subscribed-monthly-releases",
        "/subscribed-daily-releases": "subscribed-daily-releases",
        "/subscribed-instant-releases": "subscribed-instant-releases"
      };

      const path = pathMap[pathname] || "";
      if (path) {
        sessionStorage.setItem("path", path);
        sessionStorage.setItem("directLogin", true);
        navigate("/login");
      }
    }
  }, [loggedIn]);

  useEffect(() => {
    const type = getNotificationTypeFromPath();
    setNotificationType(type);

    const tryFetch = () => {
      const userId = getUserIdFromPreference();
      if (userId) {
        fetchSubscribedReleases(userId, type);
      } else {
        setTimeout(tryFetch, 200);
      }
    };
    tryFetch();
  }, []);

  const getNotificationTypeFromPath = () => {
    const pathname = window.location.pathname;
    if (pathname === "/subscribed-monthly-releases") return "Monthly";
    if (pathname === "/subscribed-daily-releases") return "Daily";
    if (pathname === "/subscribed-weekly-releases") return "Weekly";
    return "Instant";
  };

  const fetchSubscribedReleases = async (userId, notificationType) => {
      try {
          const response = await getSubscribedReleases({ userId, notificationType });
          if (response.data) {
              // Add color codes if missing
              const events = response.data.map(event => ({
                id: event.release_id,
                title: event.release_title || "No Title",
                service: event.vendor_service || "No Service",
                platform: event.platform || "Unknown Platform",
                category: event.release_category || "Unknown Category",
                relevance: event.relevance || "Unknown Relevance",
                status: event.release_status || "Unknown Status",
                ...event
            }));
              createColorCodeForRelease(events);
              setFilteredEvents(events);
          } else {
              navigate("/error");
          }
      } catch (error) {
          if (error?.response?.status === 401) {
              navigate("/logout");
          } else {
              navigate("/error");
          }
      } finally {
          setLoader(false);
      }
  };


  const backToHome = () => {
    navigate("/");
  };

  return isLoading ? (
    <Loader />
  ) : (
    <div className="min-h-list m-4">
      <div className="d-flex justify-content-between align-items-center">
        <h3>{notificationType === 'Instant' ? 'Recent' : notificationType} Subscribed Updates</h3>
        <Button onClick={backToHome}>
          <ArrowBack className="text-body mr-2" />
          Back to Home
        </Button>
      </div>
      {filteredEvents.length > 0 ? (
        <ListView events={filteredEvents} />
      ) : (
        <Alert severity="warning">
          You have not subscribed for notifications. Please navigate to Preferences to update your settings.
        </Alert>
      )}
    </div>
  );
};
